import { render, staticRenderFns } from "./analysisStatistics.vue?vue&type=template&id=12ef41b6&scoped=true"
import script from "./analysisStatistics.vue?vue&type=script&lang=js"
export * from "./analysisStatistics.vue?vue&type=script&lang=js"
import style0 from "./analysisStatistics.vue?vue&type=style&index=0&id=12ef41b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef41b6",
  null
  
)

export default component.exports